export const GETALLBILL = 'GETALLBILL'// 获取账单列表 getAllBill
export const REMOVELOCKBILL = 'REMOVELOCKBILL'// 解锁
export const CANCELBILL = 'CANCELBILL'// 取消账单 cancelBill
export const GETGROUPCOST = 'GETGROUPCOST'// 费用统计 getGroupCost
export const OFFLINEPAY = 'OFFLINEPAY'// 线下支付
export const GETBILLDETAIL = 'GETBILLDETAIL'// 获取账单详情 getBillDetail
export const EXPORTBILL = 'EXPORTBILL'// 账单导出
export const LOCKBILL = 'LOCKBILL'// 账单锁定 lockbill
export const BILLTASKPAGE = 'BILLTASKPAGE' // 时间调度任务
export const MONITORJOB = 'MONITORJOB'



// WEBPACK FOOTER //
// ./src/store/billManage/types.js